import {useEffect, useState} from 'react'
import TemperatureEventAnalysis from '../temperature-event-analysis'
import {Collapse} from 'antd'
import moment from 'moment'
import ChartPeriodControls from '@components/chart-period-controls'
import {formatPeriod} from 'helpers/dates'
const {Panel} = Collapse

const EventAnalysisSection = ({gatewaysview, targetsview}) => {
  const [activeKey, setActiveKey] = useState('1') // Controls which panel is open
  const [period, setPeriod] = useState()

  const handleChange = key => {
    const normalizedKey = Array.isArray(key) ? key[0] : key
    setActiveKey(activeKey === normalizedKey ? undefined : normalizedKey)
  }

  useEffect(() => {
    if (gatewaysview) setDaysToView(gatewaysview, 1, setPeriod)
    setActiveKey('1') // Always open it
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gatewaysview])

  const setDaysToView = days => {
    const pastDaysToView = -(days - 1)
    const keepOffset = false
    const periodEnd = gatewaysview?.rgs_timestamp ? gatewaysview.rgs_timestamp : moment().toISOString()
    const start = new moment(periodEnd)
      .local()
      .startOf('day')
      .set({hour: 0, minute: 0, second: 0, millisecond: 0})
      .add(pastDaysToView, 'days')
      .toISOString()
    const end = new moment(periodEnd)
      .local()
      .add(1, 'days')
      .set({hour: 0, minute: 0, second: 0, millisecond: 0})
      .toISOString(keepOffset)
    setPeriod({start, end})
  }

  return (
    <Collapse activeKey={activeKey} onChange={handleChange}>
      <Panel
        header={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              gap: '1rem'
            }}
          >
            <div style={{flexShrink: 0, whiteSpace: 'nowrap'}}>Event Analysis</div>

            {activeKey === '1' && (
              <>
                <div
                  style={{
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '1rem',
                    minWidth: 0,
                    flexWrap: 'nowrap'
                  }}
                >
                  <span style={{whiteSpace: 'nowrap'}}>{formatPeriod(period)}</span>
                  <div onClick={e => e.stopPropagation()} style={{display: 'inline-flex', alignItems: 'center'}}>
                    <ChartPeriodControls setDaysToView={setDaysToView} period={period} setPeriod={setPeriod} />
                  </div>
                </div>

                <div style={{flexShrink: 0, whiteSpace: 'nowrap'}}>Click chart for details</div>
              </>
            )}
          </div>
        }
        key="1"
        className="custom-panel"
      >
        <TemperatureEventAnalysis targetsview={targetsview} period={period} />
      </Panel>
    </Collapse>
  )
}

export default EventAnalysisSection
